import * as React from 'react';
import { useState } from 'react';
import ReactInputMask from 'react-input-mask';
import { FormInputWrapper, FormInputEye } from './FormInput.styles.js';
import { FormBox } from '../FormBox/FormBox.js';

const FormInput = ({ label ="Email address: " , error ="" , input ={
    type: "text",
    name: "input",
    value: "anytext@gmail.com",
    onChange: ()=>void 0,
    onClick: ()=>void 0,
    onFocus: ()=>void 0,
    onBlur: ()=>void 0
} , eye  })=>{
    const { type , name , value , onFocus , onBlur , mask  } = input;
    const [active, setActive] = useState(false);
    const [activeEye, setActiveEye] = useState(false);
    const [inputType, setInputType] = useState(type);
    const changeInputType = React.useCallback(()=>{
        setInputType(inputType === "password" ? "text" : "password");
        setActiveEye(!activeEye);
    }, [
        activeEye,
        inputType
    ]);
    return /*#__PURE__*/ React.createElement(FormBox, {
        inputName: name,
        active: active || !!value,
        label: label,
        error: error
    }, /*#__PURE__*/ React.createElement(FormInputWrapper, null, eye ? /*#__PURE__*/ React.createElement(FormInputEye, {
        "data-testid": "svg-eye",
        active: active,
        onClick: changeInputType
    }) : null, mask ? /*#__PURE__*/ React.createElement(ReactInputMask, {
        "data-testid": "form-input-mask",
        ...input
    }) : /*#__PURE__*/ React.createElement("input", {
        "data-testid": "form-input",
        autoComplete: "off",
        ...input,
        type: inputType,
        onFocus: (e)=>{
            setActive(true);
            onFocus && onFocus(e);
        },
        onBlur: (e)=>{
            setActive(false);
            onBlur && onBlur(e);
        }
    })));
};

export { FormInput };
